/** @jsx isolateComponent */
import { css } from '@emotion/core';
import { Colors } from '@zapier/design-system';
import { isolateComponent } from '@zapier/style-encapsulation';
import Container from '../Container';
const BackgroundSectionCss = (color, height) => css `
  background-color: ${Colors[color]};
  height: ${height};
  flex: 1;
`;
/**
 * A component to create a section of background with a specific color and a container.
 */
const BackgroundSection = ({ children, tint = 'light', size = 'large', height = 'auto', backgroundColor, containerPaddingTop = 0, containerPaddingBottom = 0, }) => {
    const color = backgroundColor
        ? backgroundColor
        : tint === 'light'
            ? 'neutral100'
            : 'cream';
    return (isolateComponent("section", { css: BackgroundSectionCss(color, height) },
        isolateComponent(Container, { paddingBottom: containerPaddingBottom, paddingTop: containerPaddingTop, size: size }, children)));
};
export default BackgroundSection;
